import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { calendarDateTimetoDate, formatDateTimeFromTimestamp } from '../../helpers/date/date-helper';
import { DateRangePicker } from '@heroui/react';
import { ActionButton } from "../buttons/ActionButton";
import '../../styles/date_range_selector.scss';


export const DateRangePickerComponent = forwardRef(({ defaultStart, defaultEnd, trigger, callback, allowInPast = true,
                                                      validateText = 'Valider', cancelText = 'Annuler',
                                                      alwaysShowValidateButton = false, storageKey = null }, ref) => {

  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const defaultRange = {start: defaultStart, end: defaultEnd}

  const [draftRange, setDraftRange] = useState(() => {

    if (storageKey) {
      try {
        const storedRange = localStorage.getItem(storageKey);

        if (storedRange) {
          const parsedRange = JSON.parse(storedRange);

          if (parsedRange?.start && parsedRange?.end) {
            return {
              start: formatDateTimeFromTimestamp(parsedRange.start),
              end: formatDateTimeFromTimestamp(parsedRange.end),
            };
          }
        }
      } catch {
        localStorage.removeItem(storageKey);
      }
    }

    return {
      start: formatDateTimeFromTimestamp(defaultRange.start),
      end: formatDateTimeFromTimestamp(defaultRange.end),
    };
  });

  const isDraftInPast = (() => {
    if (!draftRange?.start) return true;
    const startTs = calendarDateTimetoDate(draftRange.start).getTime();
    return startTs <= Date.now();
  })();

  const validateRange = (start, end) => {
    const startDate = calendarDateTimetoDate(start);
    const endDate = calendarDateTimetoDate(end);

    if (storageKey) {
      localStorage.setItem(storageKey, JSON.stringify({
        start: startDate.getTime(),
        end: endDate.getTime(),
      }));
    }

    callback?.(startDate, endDate);
    setIsCalendarOpen(false);
  };

  useImperativeHandle(ref, () => ({
    selectAndValidate: (start, end) => {
      const formattedRange = {
        start: formatDateTimeFromTimestamp(start),
        end: formatDateTimeFromTimestamp(end),
      };

      setDraftRange(formattedRange);
      validateRange(formattedRange.start, formattedRange.end);
    },
  }));

  const ValidateButton = () => {
    return (
      <ActionButton
        text={validateText} size="sm" disabled={!draftRange?.start || !draftRange?.end || (!allowInPast && isDraftInPast)}
        onClick={() => validateRange(draftRange?.start, draftRange?.end)}
      />
    );
  };

  return (
    <div className="relative flex gap-4 items-center">

      {trigger({ isCalendarOpen, setIsCalendarOpen })}

      <div>
        <DateRangePicker
          isOpen={isCalendarOpen}
          onOpenChange={setIsCalendarOpen}
          classNames={{
            base: 'p-0 gap-0',
            inputWrapper: 'w-full bg-transparent hover:bg-transparent focus-within:hover:bg-transparent text-white cursor-default p-0 min-h-0 h-auto',
            selectorButton: "hidden",
            label: "hidden",
            input: 'bg-perception-gray-700 rounded-md px-2 w-auto'
          }}
          value={{ start: draftRange.start, end: draftRange.end }}
          onChange={({ start, end }) => setDraftRange({ start, end })}
          className="w-full max-w-full" radius="none" granularity="minute" label={null}
          // className="absolute left-0 top-0 w-0 h-0 overflow-hidden p-0 m-0"
          CalendarBottomContent={
            <div className="flex justify-end gap-2 p-4 pt-0">
              <ActionButton text={cancelText} color="cancel" onClick={() => setIsCalendarOpen(false)} size="sm"/>
              <ValidateButton/>
            </div>
          }
        />
      </div>

      {alwaysShowValidateButton && <ValidateButton/>}

    </div>
  );
});